import { useState, useEffect } from "react";
import Sidebar from "@/components/Sidebar";
import { useSidebar } from "@/contexts/SidebarContext";

/**
 * Layout wrapper per le pagine con sidebar/navbar.
 * 
 * Comportamento responsive:
 * - Schermi grandi (≥1400px larghezza E ≥900px altezza): Sidebar verticale collassabile
 * - Schermi compatti (<1400px larghezza O <900px altezza): Navbar orizzontale + contenuto full-width
 */
export default function PageLayout({ children, user, logout, testId, className = "" }) {
  const { isCollapsed } = useSidebar();
  const [isCompactScreen, setIsCompactScreen] = useState(false);

  // Rileva se lo schermo è "compatto"
  useEffect(() => {
    const checkScreenSize = () => {
      const isCompact = window.innerWidth < 1400 || window.innerHeight < 900;
      setIsCompactScreen(isCompact);
    };
    
    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  // Layout per schermi compatti: navbar orizzontale, contenuto full-width
  if (isCompactScreen) {
    return (
      <div className="min-h-screen bg-slate-50">
        <Sidebar user={user} logout={logout} />
        <main 
          className={`pt-14 min-h-screen ${className}`}
          data-testid={testId}
        >
          {children}
        </main>
      </div>
    );
  }

  // Layout per schermi grandi: sidebar verticale con margin-left sul contenuto
  const marginLeft = isCollapsed ? "64px" : "240px";
  
  return (
    <div className="min-h-screen bg-slate-50">
      <Sidebar user={user} logout={logout} />
      <main 
        className={`h-screen flex flex-col overflow-y-auto transition-[margin-left] duration-300 ${className}`}
        style={{ marginLeft }}
        data-testid={testId}
      >
        {children}
      </main>
    </div>
  );
}
